import { render, staticRenderFns } from "./UserMorebbs.vue?vue&type=template&id=061e5956&"
import script from "./UserMorebbs.vue?vue&type=script&lang=js&"
export * from "./UserMorebbs.vue?vue&type=script&lang=js&"
import style0 from "./UserMorebbs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports